import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";

export default function NotFound() {
  const { t, lang } = useI18n();
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-3xl px-4 py-24 text-center sm:px-6 lg:px-10">
        <p className="font-mono text-sm font-semibold text-emerald-700">404</p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl">
          {t("not_found.title")}
        </h1>
        <p className="mt-4 text-base text-slate-600">
          {t("not_found.description")}
        </p>
        <Link
          to={`/${lang}`}
          data-testid="not-found-back-home"
          className="mt-8 inline-flex rounded-md bg-emerald-600 px-6 py-3 text-sm font-semibold text-white hover:bg-emerald-700"
        >
          {t("not_found.back_home")}
        </Link>
      </div>
    </section>
  );
}
